export const sumData = [52,41,45,38,35,43,79,107,95,80,67,63,57]

export function mockSumData() {
  const data = [];
  const monthNow = (new Date()).getMonth();
  let date = monthNow;
  // console.log(date, typeof date);
  for(let i=0; i< 12; i++){
    if(date == 0) {
      date += 12;
    }
    data.push({ 
        'elect_value': sumData[date], 
        'date': (date< 10 ? '0'+date : ''+date) 
      })
    date--;
  }
  return data.reverse();
}